module.exports = __webpack_public_path__ + "static/logo-pha-6b88083a2ce0ba4ecf1a612dbfdb98eb.png";